module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ee-7b6b8abcf78cfa7f4a773de556859b2f.svg";